import React, { useContext, useState, useEffect } from 'react'
import { ClipLoader } from 'react-spinners'
import InvoiceLineApi from '../services/api/InvoiceLine'
import Context from '../context/Context'
import PropTypes from 'prop-types'
import PaymentInformation from './invoice-specifications/PaymentInformation'
import InvoiceDetails from './invoice-specifications/InvoiceDetails'
import OutInvoiceDetails from './invoice-specifications/OutInvoiceDetails'
import HorizontalRow from './invoice-specifications/HorizontalRow'
import { InvoiceStatuses } from '../helpers/Constants'

const InvoiceSpecification = ({ onToggleSpecification, isToggled }) => {
  const context = useContext(Context)
  const [invoiceLines, setInvoiceLines] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const invoiceLineApi = new InvoiceLineApi()

  useEffect(() => {
    if (context.organizationSettings.showInvoiceLines === '1') {
      invoiceLineApi.getEndPoint(context.invoice.ocr)
        .then(response => response.json())
        .then(data => {
          setInvoiceLines(data)
          setLoading(false)
        })
        .catch(error => {
          console.error(error)
          setError({ message: `Ett fel uppstod, var god kontakta ${context.organizationSettings.organizationName}` })
          setLoading(false)
        })
    }

    return () => null
  }, [context.organizationSettings.showInvoiceLines, context.invoice.ocr])

  if (error) {
    return (<div className="col-12 text-center">{error.message}</div>)
  } else if (parseInt(context.invoice.invoice_status_id) === InvoiceStatuses.CREDITED) {
    return null
  } else {
    return (
      <>
        <HorizontalRow onToggleSpecification={onToggleSpecification} isToggled={isToggled} />
        <div className={isToggled ? 'fadeIn' : 'fadeOut'}>
          <PaymentInformation />
          {context.organizationSettings.showInvoiceLines === '1' &&
            <>
              {invoiceLines.length === 0
                ? <div>
                  <div className="col-12 text-center">
                    <div className='sweet-loading'>
                      <ClipLoader
                        size={75}
                        color={'#BF33BD'}
                        loading={loading}
                      />
                    </div>
                  </div>
                </div>
                : (parseInt(context.invoice.is_out_invoice) === 1)
                  ? <OutInvoiceDetails invoiceLines={invoiceLines} />
                  : <InvoiceDetails invoiceLines={invoiceLines} />
              }
            </>
          }
        </div>
      </>
    )
  }
}

InvoiceSpecification.propTypes = {
  onToggleSpecification: PropTypes.func.isRequired,
  isToggled: PropTypes.bool.isRequired
}

export default InvoiceSpecification
